export const FAVOURITE_ACTION = 'FAVOURITE_ACTION';
export const FAVOURITE_SUCCESS_ACTION = 'FAVOURITE_SUCCESS_ACTION';
export const FAVOURITE_FAILURE_ACTION = 'FAVOURITE_FAILURE_ACTION';
